import React from 'react';
import { Hash, Phone, Car, Home, Heart, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../context/LanguageContext';

export default function NumerologySection() {
  const { lang } = useLang();

  const features = [
    { icon: Hash, label_hi: 'नाम अंक', label_en: 'Name Number', desc_hi: 'क्या आपका नाम शुभ है?', desc_en: 'Is your name lucky?' },
    { icon: Phone, label_hi: 'मोबाइल नंबर', label_en: 'Mobile Number', desc_hi: 'आपका नंबर Lucky है?', desc_en: 'Is your number lucky?' },
    { icon: Car, label_hi: 'वाहन नंबर', label_en: 'Vehicle Number', desc_hi: 'सुरक्षित यात्रा के लिए', desc_en: 'Safe travels ahead?' },
    { icon: Home, label_hi: 'घर का नंबर', label_en: 'House Number', desc_hi: 'समृद्धि का द्वार', desc_en: 'Gateway to prosperity?' },
    { icon: Heart, label_hi: 'Compatibility', label_en: 'Compatibility', desc_hi: 'कितना मेल है?', desc_en: 'How compatible?' },
  ];

  return (
    <section className="section-padding" id="numerology" data-testid="numerology-section">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="text-xs tracking-[0.3em] uppercase text-gold font-semibold">
            {lang === 'hi' ? 'वैदिक अंकशास्त्र' : 'Vedic Numerology'}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl text-text-main mt-3">
            {lang === 'hi' ? 'अंकशास्त्र — अपनी संख्या जानें' : 'Numerology — Know Your Numbers'}
          </h2>
          <p className="text-text-muted mt-3 max-w-lg mx-auto">
            {lang === 'hi'
              ? 'नाम, मोबाइल, वाहन, घर — हर नंबर का अर्थ है। जानें कौन सा शुभ है, कौन सा नहीं'
              : 'Name, Mobile, Vehicle, House — every number has meaning. Find out which are lucky'}
          </p>
          <div className="divine-divider mt-6 max-w-xs mx-auto" />
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
          {features.map((f, i) => (
            <motion.div key={i} className="glass-card p-4 text-center hover:border-gold/30 transition-all cursor-pointer"
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.1 }}
              whileHover={{ y: -4 }}>
              <f.icon className="w-8 h-8 text-gold mx-auto mb-2" />
              <p className="text-sm font-medium text-text-main">{lang === 'hi' ? f.label_hi : f.label_en}</p>
              <p className="text-xs text-text-muted mt-1">{lang === 'hi' ? f.desc_hi : f.desc_en}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a href="/numerology" className="btn-gold inline-flex items-center gap-2 text-base" data-testid="numerology-cta-btn">
            <Hash className="w-5 h-5" />
            {lang === 'hi' ? 'Free Numerology Calculator खोलें' : 'Open Free Numerology Calculator'}
            <ArrowRight className="w-5 h-5" />
          </a>
          <p className="text-text-muted text-xs mt-3">
            {lang === 'hi' ? 'व्यक्तिगत अंक विश्लेषण — बिल्कुल निःशुल्क' : 'Personalized Numerology — Absolutely Free'}
          </p>
        </div>
      </div>
    </section>
  );
}
